module.exports = __webpack_public_path__ + "img/sign_bg.d8a645ad.png";